import AdditionalMenu from './additional-menu';
import mainHeader from './main-header';
import MobileMenu from './mobile-menu';
import PrimaryMenu from './primary-menu';
import HeroFullHeight from '../page/hero-full-height';
class TopBar {
    constructor() {
        Object.defineProperty(this, "topBar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closeTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.topBar = document.querySelector('#header-top-bar');
        this.closeTrigger = this.topBar?.querySelector('.top-bar__close') ?? null;
    }
    init() {
        this.closeTrigger?.addEventListener('click', this.hideTopBar.bind(this));
    }
    hideTopBar() {
        this.topBar?.classList.add('hidden');
        sessionStorage.setItem('AlertBarVisibility', '1');
        mainHeader();
        HeroFullHeight.init();
        setTimeout(() => {
            AdditionalMenu.setMenuHeight();
            PrimaryMenu.setMenuHeight();
            MobileMenu.setMenuHeight();
            MobileMenu.setAdditionalMenuHeight();
        }, 250);
    }
}
export default new TopBar();
